<template>
    <div>
        <el-row class="content">
            <el-table v-loading="loading" :data="list" tooltip-effect="light" :cell-style="cellStyle"
                      :header-cell-style="headCellStyle">
                <!--<el-table-column label="区域" align="left" prop="lawArea" :formatter="lawAreasFormat"/>-->
                <!--newView:实体类中放一个表中不存在的字段,在查询数据的时候,推送时间小于一天则为true,否则为false-->
                <el-table-column label="法规政策名称" align="left" prop="lawName" :show-overflow-tooltip="true">
					<template slot-scope="scope">
                        <span style="cursor: pointer;color: #00afff"  @click="openPage(scope.row)">{{scope.row.lawName}}</span>
                        <!--<el-tag size="mini" type="success">
                            {{lawRourceFormat(scope.row.lawRource)}}
                        </el-tag>-->
                        <el-tag size="mini" type="success">
                            new
                        </el-tag>
					</template>
				</el-table-column>
                <!--<el-table-column label="类型" align="left" prop="lawBusType" :formatter="lawBusTypesFormat"/>-->
<!--                <el-table-column label="业务类型" align="center" :show-overflow-tooltip="true" prop="ywType"/>-->
                <!--<el-table-column label="类型" align="left" prop="lawBusType" :show-overflow-tooltip="true" width="180">
                    <template slot-scope="scope">
                                <el-tag size="mini" type="success">
                                    {{lawBusTypesFormat(scope.row.lawBusType)}}
                                </el-tag>
                    </template>
                </el-table-column>-->
                <el-table-column label="业务类型" align="left" prop="lawRource" :show-overflow-tooltip="true" width="180">
                    <template slot-scope="scope">
                            {{lawRourceFormat(scope.row.lawRource)}}
                    </template>
                </el-table-column>
                <el-table-column label="发布日期" align="center" prop="lawPubtime" width="180"/>
            </el-table>
            <pagination
                    v-show="total>0"
                    :total="total"
                    :page.sync="queryParams.pageNum"
                    :limit.sync="queryParams.pageSize"
                    @pagination="getList"
            />
        </el-row>
    </div>
</template>

<script>
    import {
        listLaw,
    } from "@/api/law/jbxx/law";
    import {
        listMullevel
    } from "@/api/law/mullevel/mullevel";
    export default {
        name: 'tsflfgzc',
        data() {
            return {
                // 遮罩层
                loading: false,
                // 总条数
                total: 0,
                list: [],
                queryParams: {
                    pageNum: 1,
                    pageSize: 10,
                    lawBusTypes:'tsflfgzc'
                },
                lawBusTypes: [],
                lawAreas: [],
                lawbusTypeOptions: [],
                lawywlxOptions:[],
                /*lawtypeOptions:[],*/
            }
        },
        created() {
            /*this.getDicts("yw_flfg_lx").then(response => {
                this.lawbusTypeOptions = response.data;
            });*/
            // this.getDicts("yw_flfg_qy").then(response => {
            //     this.lawAreas = response.data;
            // });
            this.listMullevel();
            this.getList();


        },
        methods: {
            lawRourceFormat(value) {
                return this.selectDictLabels(this.lawywlxOptions, value);
            },
            selectDictLabels(datas, value) {
                // debugger
                var actions = [];
                Object.keys(datas).map((key) => {
                    if (datas[key].dictValue == ('' + value)) {
                        actions.push(datas[key].dictName);
                        return false;
                    }
                })
                return actions.join('');
            },
           /* lawBusTypesFormat(value) {
                return this.selectDictLabel(this.lawbusTypeOptions, value);
            },*/
            // lawAreasFormat(value) {
            //     return this.selectDictLabel(this.lawAreas, value);
            // },
            listMullevel(){
                const queryParams = {
                    dictType: 'law_ywlx'
                };
                listMullevel(queryParams).then(response => {
                    this.lawywlxOptions = response.data;
                });
            },
			toPage(url) {
                this.$router.push({
                    path: url,
                });
                this.$store.commit('SET_MAININDEX', url);
            },
            openPage(item){
                this.utils.windowOpen('/main/zscqzhfw/flfgzc/detail/'+item.recid);
            },
            getList() {
                this.loading = true;
                listLaw(this.queryParams).then(response => {
                    this.list = response.rows;
                    this.total = response.total;
                    this.loading = false;
                });
                /*
                this.loading = true;
                let that = this;
                setTimeout(function() {
                    that.loading = false;
                    if (that.queryParams.pageNum == 1) {
                        that.list = [
                            {recid: '1',type: '法律',ywType: '知识产权',region: '国家',newView: 'true',flfgzc: '中国质量奖管理办法',tsTime: '2021-10-29'},
                            {recid: '2',type: '法规',ywType: '质量提升',region: '山东省',newView: 'true',flfgzc: '山东省特种设备安全条例',tsTime: '2021-10-29'},
                            {recid: '3',type: '政策',ywType: '泰山品质认证',region: '山东省',newView: 'false',flfgzc: '检验检测机构监督管理办法',tsTime: '2021-10-12'},
                            {recid: '4',type: '法规',ywType: '党建引领',region: '威海市',newView: 'false',flfgzc: '关于印发《威海市知识产权质押融资风险补偿实施办法》的通知',tsTime: '2021-10-12'},
                            {recid: '5',type: '政策',ywType: '惠企政策',region: '威海市',newView: 'false',flfgzc: '威海市财政局关于印发《威海市市级专利专项资金管理实施细则》的通知（已废止）',tsTime: '2021-10-12'},
                            {recid: '6',type: '法律',ywType: '知识产权',region: '国家',newView: 'false',flfgzc: '中华人民共和国专利法',tsTime: '2021-10-12'},
                            {recid: '7',type: '法规',ywType: '质量提升',region: '山东省',newView: 'false',flfgzc: '山东省市场监督管理局关于印发《山东省市场监督管理行政处罚裁量基准（试行）》的通知',tsTime: '2021-10-12'},
                            {recid: '8',type: '政策',ywType: '泰山品质认证',region: '山东省',newView: 'false',flfgzc: '关于印发《威海市知识产权质押融资风险补偿实施办法》的通知',tsTime: '2021-10-12'},
                            {recid: '9',type: '法规',ywType: '党建引领',region: '威海市',newView: 'false',flfgzc: '严格监管 严厉处罚——建立权威性和可操作性并重的法律责任制度',tsTime: '2021-10-12'},
                            {recid: '10',type: '政策',ywType: '惠企政策',region: '威海市',newView: 'false',flfgzc: '威海市人民政府关于新冠肺炎疫情防控期间进口冷冻冷藏食品报备有关问题的通告',tsTime: '2021-10-12'},
                        ];
                    } else {
                        that.list = [
                            {recid: '11',type: '法律',ywType: '知识产权',region: '国家',newView: 'true',flfgzc: '法律标题法律标题',tsTime: '2021-10-12'},
                            {recid: '12',type: '法规',ywType: '质量提升',region: '山东省',newView: 'true',flfgzc: '法律标题法律标题法律标题',tsTime: '2021-10-12'},
                            {recid: '13',type: '政策',ywType: '泰山品质认证',region: '山东省',newView: 'false',flfgzc: '法律标题法律标题法律标题法律标题法律标题法律标题',tsTime: '2021-10-12'},
                            {recid: '14',type: '法规',ywType: '党建引领',region: '威海市',newView: 'false',flfgzc: '法律标题法律标题',tsTime: '2021-10-12'},
                            {recid: '15',type: '政策',ywType: '惠企政策',region: '威海市',newView: 'false',flfgzc: '法律标题法律标题法律',tsTime: '2021-10-12'},
                        ];
                    }
                    that.total = 15;
                }, 500);
                */
            },
            //单元格的style的回调方法
            cellStyle({row, column, rowIndex, columnIndex}) {
                //columnIndex:是一行一行的从左往右显示
                // if (columnIndex === 4) {
                //     return 'padding-left: 30px;';//left是从左往右平移
                // } else {
                //     return ''
                // }
            },
            //表头行的style的回调方法    rowIndex:行  columnIndex:列 都是从0开始的
            headCellStyle({row, column, rowIndex, columnIndex}) {
                // if (columnIndex === 4) {
                //     return 'padding-left: 150px;';
                // } else {
                //     return ''
                // }
            },
            /*openPage() {
                //此处为了演示，先写死地址
                this.utils.windowOpen('/main/main/flfgzcDetail');
            },*/

        }
    }
</script>

<style scoped="scoped">
    .item {
        margin-top: 10px;
        padding-right: 0.625rem;
    }
</style>
